import React, { useState } from 'react';
import { faqs } from '../data/mockData';
import SafeIcon from '../common/SafeIcon';

const InfoSection = () => {
  const [openFaq, setOpenFaq] = useState(0);

  return (
    <section id="support" className="py-24 bg-zinc-900 border-t border-zinc-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-16">
        
        {/* Reviews Col */}
        <div>
          <h2 className="text-2xl font-black uppercase tracking-tight mb-8">Field Reports</h2>
          <div className="space-y-6">
            {[
              { text: "The boots are a game changer for leg day recovery. Heavy squats used to leave me tight for days. Now I'm ready to move the next morning.", author: "Marcus T.", tag: "Powerlifter" },
              { text: "I keep the ForgeGun in my gym bag. 5 minutes of activation before lifting has completely changed my mobility.", author: "Sarah L.", tag: "CrossFit Athlete" }
            ].map((review, idx) => (
              <div key={idx} className="bg-zinc-950 border border-zinc-800 p-6 rounded-sm">
                <div className="flex text-red-500 mb-3 text-sm">
                  {[...Array(5)].map((_, i) => <SafeIcon key={i} name="Star" fill="currentColor" />)}
                </div>
                <p className="text-zinc-300 italic mb-4">"{review.text}"</p>
                <div className="flex items-center justify-between text-sm">
                  <span className="font-bold text-white">{review.author}</span>
                  <span className="text-zinc-500 uppercase text-xs border border-zinc-800 px-2 py-1">{review.tag}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* FAQ & Shipping Col */}
        <div>
          <h2 className="text-2xl font-black uppercase tracking-tight mb-8">Logistics & Intel</h2>
          
          <div className="mb-8 space-y-2">
            {faqs.map((faq, idx) => (
              <div key={idx} className="border border-zinc-800 bg-zinc-950 rounded-sm overflow-hidden">
                <button 
                  className="w-full px-6 py-4 text-left flex justify-between items-center font-bold text-sm uppercase tracking-wider hover:text-red-500 transition-colors"
                  onClick={() => setOpenFaq(openFaq === idx ? -1 : idx)}
                >
                  {faq.q}
                  <SafeIcon name={openFaq === idx ? 'Minus' : 'Plus'} className="text-zinc-500" />
                </button>
                {openFaq === idx && (
                  <div className="px-6 pb-4 text-zinc-400 text-sm leading-relaxed border-t border-zinc-800 pt-4">
                    {faq.a}
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="bg-zinc-950 border border-zinc-800 p-4 flex flex-col items-center text-center gap-2">
              <SafeIcon name="Truck" className="text-2xl text-zinc-400" />
              <h4 className="font-bold text-sm uppercase">Free Shipping</h4>
              <p className="text-xs text-zinc-500">On domestic orders over $150</p>
            </div>
            <div className="bg-zinc-950 border border-zinc-800 p-4 flex flex-col items-center text-center gap-2">
              <SafeIcon name="Shield" className="text-2xl text-zinc-400" />
              <h4 className="font-bold text-sm uppercase">1-Year Warranty</h4>
              <p className="text-xs text-zinc-500">Hardware protection standard</p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default InfoSection;